import { render, staticRenderFns } from "./EditBehaviorEditor.vue?vue&type=template&id=bde4e014&"
import script from "./EditBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./EditBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports